import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export function SafetyMondaySettings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/teams/safety").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const toggle = async (enabled) => {
    try {
      await api.post("/teams/safety", { enabled });
      setS({ ...s, enabled });
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <section className="bg-white rounded-2xl border-2 border-slate-200 p-4 flex items-center gap-3 rise print:hidden" data-testid="safety-monday-settings">
      <span className="w-12 h-12 rounded-xl bg-red-600 text-white grid place-items-center"><ShieldCheck className="w-6 h-6" /></span>
      <div className="flex-1">
        <div className="font-display text-xl font-bold uppercase">Sécurité du lundi</div>
        <div className="text-sm text-slate-600">Leçon sécurité courte envoyée chaque lundi à 6h30</div>
        {s.last && <div className="text-xs text-slate-500" data-testid="safety-monday-last">Dernière : {s.last}</div>}
      </div>
      <Switch checked={s.enabled} onCheckedChange={toggle} data-testid="safety-monday-toggle" />
    </section>
  );
}
